import React from 'react'
import Navbar from '../../components/Navbar'
import Sponsor from '../../components/Home/Sponsor'
import AboutUs from '../../components/Home/AboutUs'
import Building from '../../components/Home/Building'
import Team from '../../components/Home/Team'
import Contact from '../../components/Home/Contact'
import Hero from '../../components/Home/Hero'
import Footer from '../../components/Home/Footer'
import Donate from '../../components/Home/Donate'
import OurMission from '../../components/Home/OurMission'
import OurPromise from '../../components/Home/OurPromise'
function Home() {
  return (
    <>
      <Navbar />
      <div className='h-[90px] w-full'></div>

      <Hero id={'hero'} />


      <AboutUs id={'aboutUs'} />
      <OurMission/>
      <OurPromise/>
      <Building id={'building'} />

      <section id='team'>
        <Team/>
      </section>
      <Sponsor />
      <Donate id={'donate'}/>
      <Contact id={'contact'} />

      <Footer />
    </>
  )
}

export default Home